
import { defineComponent } from 'vue'
import VitalSigns from './VitalSigns.vue'
import EncounterList from '../encounter/EncounterList.vue'
import PatientNotes from './PatientNotes.vue'

export default defineComponent({
  name: 'NurseWorkflow',
  props: ['patient'], 
  components: {
    VitalSigns,
    EncounterList,
    PatientNotes
  },
  data () {
    return {
      tab: null,
      patientSummary: {
        name: 'Strawberry Shortcake Jamz',
        birthdate: '01 Jan 1980',
        age: '20',
        location: 'Ward 12',
        hrn: 332211
      },
      admissionDate: new Date().toISOString().substr(0, 10),
    }
  }
})
